import { render, staticRenderFns } from "./UpsellButton.vue?vue&type=template&id=818f30ca"
import script from "./UpsellButton.vue?vue&type=script&lang=js"
export * from "./UpsellButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports